module.exports = __webpack_public_path__ + "static/poster_boy_instagram-bdce3edb11cdda22f7b951b6ab4ce40e.jpg";